<template>
    <form
    id="enquire_form"
    @submit.prevent="submit"
    method="post"
    :class="{'success' : success}"
    class="full">
        
    <div v-if="success" class="message-sent">
        <img alt="Vue logo" src="../assets/Logo-9T-Thick-White.svg"><br>
        <h2>Thank you for your enquiry</h2>
        <p>A member of our team will be in touch shortly.</p>
        <button type="submit" class="bordered" @click="reloadForm">Send another enquiry</button>
    </div>
        
        <span v-if="success" id="form-body"></span>
        <span v-else id="form-body">
        <!-- Google tag manager GCLID offline tracking managed by luux-media.com -->
            <input data-drupal-selector="edit-gclid" type="hidden" name="utm_gclid" value="">
            <input data-drupal-selector="edit-utm-source" type="hidden" name="utm_source" value="">
            <input data-drupal-selector="edit-utm-medium" type="hidden" name="utm_medium" value="">
            <input data-drupal-selector="edit-utm-campaign" type="hidden" name="utm_campaign" value="">
            <input data-drupal-selector="edit-utm-content" type="hidden" name="utm_content" value="">
            <input data-drupal-selector="edit-utm-term" type="hidden" name="utm_term" value="">

            <input type="hidden" name="_token" :value="csrf">
                <div class="grid-container form-enquiry"> 
                <div class="input-wrapper name">
                    <label for="name">Name</label>
                    <input
                        required
                        type="text"
                        id="name"
                        class=""
                        name="name"
                        v-model="userData.name">
                </div>
                <div class="input-wrapper email">
                    <label for="email">Email</label>
                    <input 
                        required               
                        type="email"
                        id="email"
                        size="35"
                        name="email"
                        v-model="userData.email">
                </div>
                <div class="input-wrapper phone">
                    <label for="phone">Telephone</label>
                    <input
                        required
                        type="text"
                        id="phone"
                        class=""
                        name="phone"
                        v-model="userData.phone">
                </div>
                <div class="input-wrapper message">
                    <label for="message">Message</label>
                    <textarea style="height: 90px;" type="message" v-model="userData.message" class="form-control" rows="4" cols="100" required 
                     name="message" id="message"></textarea>
                </div>
                <div class="input-wrapper privacy">      
                    <span class="privacy">
                        <label class="checkbox-container">
                            <input type="checkbox" v-model="userData.privacy" name="privacy" value="Agreed" id="privacy" required >
                            <span class="checkmark"></span>    
                        </label>
                        <span>
                        The personal information you provide will be used exclusively to process your request.
                        <br>We won't share your information with third parties.
                        <br>We will not disclose any information to other organisations unless we are required by law to do so or to prevent fraud.</span>
                    </span>
                </div>
            </div>
            <button id="contact-submit" class="bordered" type="submit">Send</button><br>
            
        </span>
    </form>
</template>

<script>
import Vue from 'vue'

export default {
    name: "sell-watch-form-component",
    data() {
        let currentUrl = window.location.origin + this.$route.fullPath;
        return {/* 
            showOptions: false,
            showStatusTitles: false, */
            currentUrl: "",
            userData: {
                form_url: currentUrl,
                form_origin: 'Sell Your Watch',
                name: '',
                phone: '',
                name: '',
                model: '',
                sku: '',
                email: '',
                message: '',
                privacy: [],
            },
/* 		    statusTitles: [
		      { name: "Ms", id: 1 },
		      { name: "Miss", id: 2 },
		      { name: "Mrs", id: 3 },
		      { name: "Mr", id: 4 },
		      { name: "Sir", id: 5 }
		    ], *//* 
		    selectedStatusTitle: null, */
            errors: {},
            success: false,
            loaded: true,
            csrf: document.head.querySelector('meta[name="csrf-token"]').content,
        } 
    },
/*     created() {
        this.currentUrl = window.location.href;
    }, */
    methods: {
        submit() {
                if (this.loaded) {
                    this.loaded = false;
                    this.success = false;
                    this.errors = {};
                     this.$axios.post('/submit', this.userData ).then(response => { 
                        this.userData.form_origin = '';
                        this.userData.title = '';
                        this.userData.statusTitle = '';
                        this.userData.firstName = '';
                        this.userData.lastName = '';
                        this.userData.phone = '';
                        this.userData.model = '';
                        this.userData.sku = '';
                        this.userData.email = '';
                        this.userData.message = '';
                        this.userData.form_url = '';
                        this.userData.privacy = [];
                        this.loaded = true;
                        this.success = true;
                        // window.scrollTo(0,0);
                    }).catch(error => {
                      if (error.response.status === 422) {
                          this.errors = error.response.data.errors || {};
                          }
                    });
                }
        },
        reloadForm() {
            this.errors = {};
            this.success = false;
            this.loaded = true;
            this.$forceUpdate();      
          },
      },
 
    }
</script>
<style>

</style>